import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { parseTime } from "@/utils/util.js";
import dateRange from '@/components/newdaterange/index';
import { getRequestPriceList, syncErpRequestPrice, syncRequestPriceStatus } from '@/services/order/inquiry';
import { getSellerOptions } from '@/services/order/orderList';
export default {
  name: 'inquiryList',
  i18n: require('./i18n-inquiry'),
  components: {
    dateRange: dateRange
  },
  data: function data() {
    return {
      sellerList: [],
      queryParam: {
        askPriceNoKeyword: '',
        erpCustomerKeyword: '',
        sellerCode: [],
        startDate: '',
        endDate: '',
        page: 1,
        size: 20
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      syncLoading: false
    };
  },
  computed: {
    columns: function columns() {
      return [
      // 询价编号    
      {
        title: this.$t('inquiryList.askPriceNo'),
        dataIndex: 'askPriceNo',
        width: 150,
        scopedSlots: {
          customRender: 'askPriceNo'
        }
      },
      // 得意先情报
      {
        title: this.$t('inquiryList.erpCustomerName'),
        dataIndex: 'erpCustomerName',
        width: 150,
        scopedSlots: {
          customRender: 'erpCustomerName'
        }
      },
      // 担当者
      {
        title: this.$t('inquiryList.sellerName'),
        dataIndex: 'sellerName',
        width: 150
      },
      // // 询价状态
      // {
      //     title: this.$t('inquiryList.status'),
      //     dataIndex: 'status',
      //     width: 150,
      //     scopedSlots: {
      //         customRender: 'status',
      //     },
      // },
      // 询价时间
      {
        title: this.$t('inquiryList.createTime'),
        dataIndex: 'createTime',
        width: 150
      },
      // 操作
      {
        title: this.$t('inquiryList.action'),
        dataIndex: 'action',
        width: 150,
        scopedSlots: {
          customRender: 'action'
        }
      }];
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.getData();
    getSellerOptions({
      scene: 2
    }).then(function (res) {
      if (res.data.code == 200) {
        _this.sellerList = res.data.data.map(function (item) {
          return {
            value: item.sellerCode,
            label: item.sellerName
          };
        });
      }
    });
  },
  methods: {
    getData: function getData() {
      var _this2 = this;
      this.tableLoading = true;
      var params = _objectSpread(_objectSpread({}, this.queryParam), {}, {
        sellerCode: this.queryParam.sellerCode.join(',')
      });
      getRequestPriceList(params).then(function (res) {
        if (res.data.code == 200) {
          _this2.tableData = res.data.data.list;
          _this2.total = res.data.data.totalNum;
        }
      }).finally(function () {
        _this2.tableLoading = false;
      });
    },
    handleDateChange: function handleDateChange(dateRange) {
      if (dateRange.startDateClone != undefined) {
        if (_typeof(dateRange.startDateClone) == "object") {
          this.queryParam.startDate = parseTime(dateRange.startDateClone._d, "{y}-{m}-{d}");
        } else {
          this.queryParam.startDate = dateRange.startDateClone;
        }
      } else {
        this.queryParam.startDate = "";
      }
      if (dateRange.endDateClone != undefined) {
        if (_typeof(dateRange.endDateClone) == "object") {
          this.queryParam.endDate = parseTime(dateRange.endDateClone._d, "{y}-{m}-{d}");
        } else {
          this.queryParam.endDate = dateRange.endDateClone;
        }
      } else {
        this.queryParam.endDate = "";
      }
    },
    handleClickQueryButton: function handleClickQueryButton() {
      this.queryParam.page = 1;
      this.getData();
    },
    hangeTableChange: function hangeTableChange(_ref) {
      var current = _ref.current,
        pageSize = _ref.pageSize;
      this.queryParam.page = current;
      this.queryParam.size = pageSize;
      this.getData();
    },
    syncErpRequestPriceFuc: function syncErpRequestPriceFuc() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var resOrder, resErpOrder;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this3.syncLoading = true;
              _context.p = 1;
              _context.n = 2;
              return syncErpRequestPrice();
            case 2:
              resOrder = _context.v;
              if (resOrder.data.code == 200) {
                _this3.$message.success(_this3.$t('public.updateSuccessfully'));
                _this3.getData();
              }
              _context.n = 3;
              return syncRequestPriceStatus();
            case 3:
              resErpOrder = _context.v;
            case 4:
              _context.p = 4;
              _this3.syncLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 4, 5]]);
      }))();
    }
  }
};